// extracted by mini-css-extract-plugin
export default {"chart":"AllocationHistoryChart_chart__T-2nx"};